import { render, staticRenderFns } from "./BuySupportModal.vue?vue&type=template&id=a3aa8b56"
import script from "./BuySupportModal.vue?vue&type=script&lang=js"
export * from "./BuySupportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports